export default "__VITE_ASSET__IkIsO7Pf__"